export enum Constants {
	id = 'last_name',
	name = 'LastName',
}
